export default __webpack_public_path__ + "static/mapa_argentina-f8ecd8e686485579e22dd1535b0c1ff1.svg";